module.exports = __webpack_public_path__ + "img/36600.4761ff42.jpg";